import React from "react";
import {
    FDC_GAMES,
    FDL_GAMES,
    CASCADE_GAMES,
    BURNING_7S_AND_MORE,
    BURNING_7S_SCATTERS_RESPIN,
    OTHER_GAMES,
    PB_GAMES,
    BONUS_GAMES,
    WAYS_GAMES,
} from "../config/GameConfig";
import GameThumbnail from "./GameThumbnail";

interface GameTilesProps {
    handlePlayForFree: (gameId: number) => void;
    handlePlayForReal: (gameId: number) => void;
}

const GameTiles: React.FC<GameTilesProps> = ({
    handlePlayForFree,
    handlePlayForReal,
}) => {
    const renderGameColumn = (games: any[], title: string) => (
        <div className="game-column">
            <h3 className="column-title">{title}</h3>
            <div className="column-games">
                {games.map((game) => (
                    <GameThumbnail
                        key={game.gameId}
                        game={game}
                        handlePlayForFree={handlePlayForFree}
                        handlePlayForReal={handlePlayForReal}
                    />
                ))}
            </div>
        </div>
    );

    const renderGameSection = (games: any[], title: string) => (
        <div className="game-column other-games-column">
            <h3 className="column-title">{title}</h3>
            <div className="other-games-grid">
                {games.map((game) => (
                    <GameThumbnail
                        key={game.gameId}
                        game={game}
                        handlePlayForFree={handlePlayForFree}
                        handlePlayForReal={handlePlayForReal}
                    />
                ))}
            </div>
        </div>
    );

    return (
        <div className="columns-container">
            <div className="main-columns">
                {renderGameColumn(FDC_GAMES, "FDC Games")}
                {renderGameColumn(FDL_GAMES, "FDL Games")}
                {renderGameColumn(CASCADE_GAMES, "Cascades")}
                {renderGameColumn(BURNING_7S_AND_MORE, "Burning 7s and More")}
            </div>

            {renderGameSection(
                BURNING_7S_SCATTERS_RESPIN,
                "Burning 7s Scatters Respin",
            )}
            {renderGameSection(PB_GAMES, "Power Bet Games")}
            {renderGameSection(BONUS_GAMES, "Buy Bonus Games")}
            {renderGameSection(WAYS_GAMES, "Ways Games")}
            {renderGameSection(OTHER_GAMES, "Other Games")}
        </div>
    );
};

export default GameTiles;
